<script>
import InfoBox from '@components/info-box'
import deepLink from '@/mixins/deeplink.js'

export default {
  name: 'NotNotificationReasons',
  components: {
    InfoBox,
  },
  mixins: [deepLink()],
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    infoBoxData () {
      return {
        styles: {
          color: 'red',
        },
      }
    },
  },
  methods: {
    dispatchReasonDeeplink (deeplink) {
      if (deeplink) this.thirdPartyDeepLink(deeplink)
    }
  },
}
</script>

<template>
  <div :class="$style.container">
    <div
      v-for="(reason, i) in componentData.reasons"
      :class="$style.holder"
      :key="i"
    >
      <button @click="dispatchReasonDeeplink(reason.deepLink)">
        <div :class="$style.container__content">
          <div :class="$style.container__info">
            <img
              v-if="reason.image"
              :src="reason.image"
              :alt="reason.name"
            >
            <p>{{ reason.name }}</p>
          </div>
          <div
            v-if="!(reason.isOk==null)"
            :class="$style.container__icon"
            :style="{ 'background-color': reason.isOk ? '#1fd8b5' : '#ff441f' }"
          >
            {{ reason.isOk ? '&#10003;' : '&#10005;' }}
          </div>
        </div>
      </button>
      <InfoBox
        v-if="reason.message"
        :data="JSON.parse(JSON.stringify({
          icon: null,
          text: reason.message,
        }))"
        :styles="JSON.parse(JSON.stringify(infoBoxData.styles))"
        :class="$style.infoBox"
        info
      />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  display: flex;
  flex-flow: column wrap;
  margin: $size-spacing-small;

  background-color: transparent;

  &__content {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;

    img {
      max-width: 2rem;
      max-height: 2rem;
    }

    p {
      margin-left: 0.75rem;
    }
  }

  &__info {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: center;
    width: 10rem;
  }

  &__checkbox {
    margin: 0;
    line-height: 10px;
    margin-right: 1rem;
  }

  &__icon {
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 5px;
    color: $white;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.holder {
  & > button {
    @extend %typography-medium;

    width: 100%;
    background-color: $light-gray;
    border-radius: 10px;
    height: 3rem;
    padding: 0.5rem 1rem;

    margin-bottom: 0.5rem;
    &:active {
      transform: translateY(-0.1rem);
    }
    &:focus {
      outline: none;
    }
  }
}
.infoBox {
  padding: 0;
  margin-bottom: -0.5rem;
}
</style>
